const initialState = {
    quote: {
        id: 0, 
        requestNumber: '', 
        date: '', 
        customerNumber: '', 
        customerName: '', 
        poNumber: '', 
        orderedBy: ''
    },
    fetching: false,
    fetched: false,
    error: null
}

export function quoteReducer(state = initialState, action) {

    switch (action.type) {

        case "FETCH_QUOTE": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "FETCH_QUOTE_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "FETCH_QUOTE_FULFILLED": {
            return { ...state, fetching: false, fetched: true, quote: action.payload.data }
        }

        case "QUOTE_ERROR": {
            return { ...state, error: null }
        }

        default:
            return state
    }
}